import React, { Component } from 'react';
import Setup from './boot/Setup';

class App extends Component {
	render() {
		return <Setup />;
	}
}

export default App;
